import React from "react";
import "./FlipButton.css";

const FlipButtonComponent = ({ direction = 'left', onClickLeft, onClickRight }) => {
    // console.log(`FlipButtonComponent rendering: direction=${direction}`);
    return (
        <div className="button-container">
            <button className={`flip-button left`} onClick={onClickLeft}></button>
            <button className={`flip-button right`} onClick={onClickRight}></button>
        </div>
    );
};

export default FlipButtonComponent;